import { AIPromptTemplatesList } from '../components/AIPromptTemplatesList';

export const AIPromptTemplatesPage = () => {
  return <AIPromptTemplatesList />;
};
